<div class="diff-viewer">
  <!-- Header with legend -->
  <div class="diff-header" *ngIf="showLegend">
    <div class="diff-title">
      <i class="fa-solid fa-code-compare"></i>
      <span>{{ title }}</span>
    </div>
    <div class="diff-legend">
      <span class="legend-item added">Added</span>
      <span class="legend-item removed">Removed</span>
    </div>
  </div>

  <!-- Diff content -->
  <div class="diff-content" [class.no-header]="!showLegend">
    <div *ngIf="!hasDifferences && (originalContent || modifiedContent)" class="no-changes">
      <i class="fa-solid fa-check-circle"></i>
      <span>No changes detected</span>
    </div>
    <div *ngIf="hasDifferences || (!originalContent && !modifiedContent)"
         class="diff-html"
         [innerHTML]="diffHtml">
    </div>
  </div>
</div>
